import { ApiClient } from './ApiClient.js';

/**
 * 权限认证中心端点发现服务
 * @param {any} serverAddr 权限认证中心服务地址
 */
let Discovery = function (serverAddr) {
    /**
     * 权限认证中心服务地址
     * */
    let ServerAddress = serverAddr;
    /**
    * 权限认证中心端点信息地址
    * */
    let ServerDiscovery = ServerAddress + '/.well-known/openid-configuration';
    /**
    * 上次请求时间
    * */
    let RequestTime = 0;
    /**
    * 端点信息
    * */
    let DiscoveryResult = null;
    /**
    * 数据缓存有效期
    * */
    this.Interval = 600;
    /**
     * 端点发现文档
     * */
    this.Document = function () {
        var _this = this;
        var currertTime = new Date();
        var time = sessionStorage.getItem('DiscoveryDocumentRequestTime');
        if (time) {
            RequestTime = new Date(time);
        }
        var duration = (currertTime - RequestTime) / 1000;
        if (duration >= _this.Interval) {
            RequestDocument();
        } else {
            var documentData = sessionStorage.getItem('DiscoveryDocument');
            if (documentData) {
                DiscoveryResult = new DiscoveryDocument(documentData);
            }
            else {
                RequestDocument();
            }
        }
        return DiscoveryResult;
    }

    function RequestDocument() {
        ApiClient.Get(ServerDiscovery, false, ApiClient.UrlEncodedHeader, null, function (data) {
            RequestTime = new Date();
            DiscoveryResult = new DiscoveryDocument(data);
            sessionStorage.setItem('DiscoveryDocument', data);
            sessionStorage.setItem('DiscoveryDocumentRequestTime', RequestTime);
        }, null);
    }
}
/**
 * 端点发现文档
 * @param {any} json 服务器返回的数据
 */
let DiscoveryDocument = function (json) {
    var result = undefined;
    switch (typeof json) {
        case 'string':
            result = JSON.parse(json);
            break;
        case 'object':
            result = json;
            break;
    }

    this.Issuer = result?.issuer;
    this.JwksUri = result?.jwks_uri;
    this.AuthorizationEndpoint = result?.authorization_endpoint;
    this.TokenEndpoint = result?.token_endpoint;
    this.UserinfoEndpoint = result?.userinfo_endpoint;
    this.EndSessionEndpoint = result?.end_session_endpoint;
    this.CheckSessionIframe = result?.check_session_iframe;
    this.RevocationEndpoint = result?.revocation_endpoint;
    this.IntrospectionEndpoint = result?.introspection_endpoint;
    this.DeviceAuthorizationEndpoint = result?.device_authorization_endpoint;
    this.FrontchannelLogoutSupported = result?.frontchannel_logout_supported;
    this.FrontchannelLogoutSessionSupported = result?.frontchannel_logout_session_supported;
    this.BackchannelLogoutSupported = result?.backchannel_logout_supported;
    this.BackchannelLogoutSessionSupported = result?.backchannel_logout_session_supported;
    this.ScopesSupported = result?.scopes_supported;
    this.ClaimsSupported = result?.claims_supported;
    this.GrantTypesSupported = result?.grant_types_supported;
    this.ResponseTypesSupported = result?.response_types_supported;
    this.ResponseModesSupported = result?.response_modes_supported;
    this.TokenEndpointAuthMethodsSupported = result?.token_endpoint_auth_methods_supported;
    this.IdTokenSigningAlgValuesSupported = result?.id_token_signing_alg_values_supported;
    this.SubjectTypesSupported = result?.subject_types_supported;
    this.CodeChallengeMethodsSupported = result?.code_challenge_methods_supported;
    this.RequestParameterSupported = result?.request_parameter_supported;
}

export { Discovery }